import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

function readUser() {
  try {
    const raw = typeof window !== 'undefined' ? localStorage.getItem('adeeb-user') : null;
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

// Pre-positioned twinkle stars overlaid on the image
const SPARKLES = [
  { top: '10%', left: '12%', size: 8,  delay: 0    },
  { top: '18%', left: '78%', size: 10, delay: 0.7  },
  { top: '24%', left: '45%', size: 6,  delay: 1.4  },
  { top: '32%', left: '22%', size: 7,  delay: 0.3  },
  { top: '40%', left: '88%', size: 9,  delay: 1.1  },
  { top: '14%', left: '60%', size: 5,  delay: 1.9  },
  { top: '52%', left: '8%',  size: 7,  delay: 0.9  },
  { top: '60%', left: '92%', size: 6,  delay: 0.4  },
  { top: '8%',  left: '34%', size: 5,  delay: 2.1  },
  { top: '20%', left: '93%', size: 8,  delay: 1.6  },
  { top: '46%', left: '52%', size: 5,  delay: 0.6  },
  { top: '12%', left: '6%',  size: 6,  delay: 1.3  },
];

export default function HomeBanner() {
  const [user, setUser] = useState(readUser);

  useEffect(() => {
    const refresh = () => setUser(readUser());
    window.addEventListener('storage', refresh);
    window.addEventListener('adeeb-auth-change', refresh);
    return () => {
      window.removeEventListener('storage', refresh);
      window.removeEventListener('adeeb-auth-change', refresh);
    };
  }, []);

  return (
    <section className="home-banner" aria-label="Welcome to Deenlit">
      <div
        className="home-banner-bg"
        style={{ backgroundImage: 'url(/branding/deenlit-banner.png)' }}
        aria-hidden="true"
      />
      <div
        className="home-banner-img"
        style={{ backgroundImage: 'url(/branding/deenlit-banner.png)' }}
        aria-hidden="true"
      />
      <div className="home-banner-tint" aria-hidden="true" />
      <div className="home-banner-vignette" aria-hidden="true" />

      <div className="home-banner-sparkles" aria-hidden="true">
        {SPARKLES.map((s, i) => (
          <span
            key={i}
            className="home-banner-sparkle"
            style={{
              top: s.top,
              left: s.left,
              width: s.size,
              height: s.size,
              animationDelay: `${s.delay}s`,
            }}
          />
        ))}
      </div>

      <div className="home-banner-inner">
        <img className="home-banner-logo" src="/branding/deenlit-logo.png" alt="DeenLit" width="2172" height="724" />

        <h1 className="home-banner-title" aria-label="A World of Stories Awaits Inside">
          <span className="home-banner-title-line">A World of Stories</span>
          <span className="home-banner-title-line is-accent">Awaits Inside</span>
        </h1>
        <h2 className="home-banner-tagline">Islamic Books for Children &amp; Teens</h2>

        <p className="home-banner-sub">
          Discover Islamic children’s books in English and Arabic across Islam, history,
          fiction, non-fiction, poetry and more.
        </p>

        <div className="home-banner-cta">
          <Link to="/category/all" className="home-banner-btn home-banner-btn-primary">
            <svg viewBox="0 0 24 24" width="16" height="16" aria-hidden="true" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20" />
              <path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z" />
            </svg>
            Browse the Library
          </Link>
          {user ? (
            <Link to="/profile" className="home-banner-btn home-banner-btn-ghost">
              My Shelf
              <svg viewBox="0 0 24 24" width="14" height="14" aria-hidden="true" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round">
                <polyline points="9 6 15 12 9 18" />
              </svg>
            </Link>
          ) : (
            <Link to="/register" className="home-banner-btn home-banner-btn-ghost">
              Sign up free
              <svg viewBox="0 0 24 24" width="14" height="14" aria-hidden="true" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round">
                <polyline points="9 6 15 12 9 18" />
              </svg>
            </Link>
          )}
        </div>

      </div>

      <div className="home-banner-fade" aria-hidden="true" />
    </section>
  );
}
